import { Box, Grid, Typography } from "@material-ui/core";
import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    totalBox: {
      marginBottom: "15px",
      width: "80%",
    },
    productText: {
      color: theme.palette.dark.main,
      fontWeight: "bold",
      justifyContent: "left",
      display: "flex",
    },
    totalText: {
      color: theme.palette.dark.main,
      fontWeight: "bold",
      justifyContent: "right",
      display: "flex",
    },
  })
);

export default function InvoiceTotalData(props: IProps) {
  const classes = useStyles();
  const { t } = useTranslation();
  const { invoiceTotal } = props;

  return (
    <React.Fragment>
      <Box className={classes.totalBox}>
        <Typography></Typography>
        <Grid container>
          <Grid item xs={8}>
            <Typography className={classes.productText}>
              {t("total")}
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography className={classes.totalText}>
              {invoiceTotal}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </React.Fragment>
  );
}

interface IProps {
  invoiceTotal: string;
}
